import React from "react";
import ExternalLink from "./ExternalLink";
import { profiles } from "../content";

function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="shell site-footer-inner">
        <p className="footer-name">Max Kotas</p>
        <ul className="footer-links">
          <li>
            <a href={profiles.email}>{profiles.emailLabel}</a>
          </li>
          <li>
            <ExternalLink href={profiles.github}>GitHub</ExternalLink>
          </li>
          <li>
            <ExternalLink href={profiles.linkedin}>LinkedIn</ExternalLink>
          </li>
        </ul>
      </div>
    </footer>
  );
}

export default SiteFooter;
